export class GoodReceipt {
    artikel_id: number;
    charge: string;
    mhd: Date | string;
    lagerplatz_id_ziel: number;
    menge: number;
    bestellung_extern_id: number;
}
